import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow, FormControlLabel, Checkbox } from '@mui/material';
import { Autocomplete, TextField, IconButton } from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const ChecklistPropertyListItemComponent = ({ property, index, checklistProperties, validation, onPropertyChanged, onDelete }) => {
  const [t] = useTranslation();

  return (
    <TableRow>
      <TableCell>
        <Autocomplete
          fullWidth
          label={t('Checklist.Property')}
          value={property.propertyId}
          simpleValue
          options={checklistProperties}
          valueKey='propertyId'
          labelKey='propertyName'
          onChange={event => onPropertyChanged('propertyId', event, index)}
          error={!isValid(validation[index].propertyId)}
          helperText={getErrors(validation[index].propertyId)}
          isSearchable={true}
        />
      </TableCell>
      <TableCell>
        <TextField
          fullWidth
          label={t('Checklist.DefaultValue')}
          value={property.defaultValue || ''}
          onChange={event => onPropertyChanged('defaultValue', event, index)}
        />
      </TableCell>
      <TableCell align='center'>
        <FormControlLabel
          control={
            <Checkbox
              checked={property.mandatory}
              color='primary'
              onChange={event => onPropertyChanged('mandatory', event.target.checked, index)}
            />
          }
        />
      </TableCell>
      <TableCell align='right'>
        <IconButton type='delete' fontSize='medium' color='transparent' tooltip={t('Tooltips.Delete')} onClick={onDelete(index)} />
      </TableCell>
    </TableRow>
  );
};

ChecklistPropertyListItemComponent.propTypes = {
  property: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  checklistProperties: PropTypes.array,
  validation: PropTypes.object,
  onPropertyChanged: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default ChecklistPropertyListItemComponent;
